"use strict";
// @ts-ignore
try {
    self['workbox:strategies:7.2.0'] && _();
}
catch (e) { }
